import { styled } from "../imports";
import { prop, spaceProp, space } from "../utils";
import { gridContainerProps, gridItemProps } from "../props";
import Flex from "./Flex";
export var supportsModernGrid = "@supports (grid-row-gap:0)";
var Columns = /*#__PURE__*/styled(Flex, {
  label: "Columns",
  target: "css-ynuffj0"
})(">:first-child{> *{flex-grow:1;", function (p) {
  return p.columnWidth && "width: " + space(p.columnWidth)(p);
}, ";", prop("columnCount", function (val, rawVal) {
  return "width:" + 100 / rawVal + "%";
}), ";// this has to be here to work\n      ", supportsModernGrid, "{width:initial;padding-top:initial;padding-left:initial;}}", supportsModernGrid, "{display:grid;", gridContainerProps, ";", function (p) {
  return p.columnWidth && "grid-template-columns: repeat(\n          auto-fit,\n          minmax(" + space(p.columnWidth)(p) + ", 1fr)\n        )";
}, ";", prop("columnCount", function (val, rawVal) {
  return "grid-template-columns: repeat(" + rawVal + ", 1fr)";
}), ";", spaceProp(function (val) {
  return "grid-gap:" + val;
}), ";margin-top:initial;margin-left:initial;}}");
Columns.Item = /*#__PURE__*/styled(Flex.Item, {
  target: "css-ynuffj1"
})(supportsModernGrid, "{", gridItemProps, ";}");
Columns.Item.displayName = "Columns.Item";
Columns.displayName = "Columns";
Columns.defaultProps = {
  gapType: "padding",
  wrap: true
};
export default Columns;